import React from 'react';

const RING = '0 0 0 3px #fff, 0 0 0 5px rgba(196,21,28,0.22), 0 10px 24px -12px rgba(0,0,0,0.35)';

const PLACEHOLDERS = [
  '/leadership-avatars/1.png?v=snap',
  '/leadership-avatars/2.png?v=snap',
  '/leadership-avatars/3.png?v=snap',
  '/leadership-avatars/4.png?v=snap',
];

export default function LeadershipAvatar({ index = 0, name = '', photo, className = 'h-24 w-24' }) {
  const src = photo || PLACEHOLDERS[index % PLACEHOLDERS.length];
  return (
    <img
      src={src}
      alt={name || 'Leadership photo'}
      className={`${className} rounded-full object-cover bg-gray-100`}
      style={{ boxShadow: RING }}
    />
  );
}
